import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'srcReact/components/common2/Button'
import { isPastDateWithTZ } from 'srcReact/helpers/datetimeHelper'
import { redirectToPage } from 'srcReact/helpers/history'
import { mixrActions } from 'srcReact/Mixr/actions'
import SaveDraftModal from 'srcReact/Mixr/components/SaveDraftModal'
import styles from './styles.module.scss'
import { useBeforeunload } from 'react-beforeunload'
import LinkButton from 'srcReact/components/common2/LinkButton'
import { getCreateMixrParams } from 'srcReact/Mixr/helpers/getCreateMixrParams'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { appConstantSettings } from 'srcReact/appConstantSettings'

function Preview(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [currentPath, setCurrentPath] = useState('')

  const [isSaveDraftModalOpen, setIsSaveDraftModalOpen] = useState(false)
  const unblockRef = useRef()
  const isDraftSaved = useRef(false)
  const [errorDraft, setErrorDraft] = useState('')
  const [errorPublish, setErrorPublish] = useState('')

  const {
    common: { isMobile, isNative },
    mixr: { mixr, saveDraft, createUpdateErrors },
    mixr: {
      mixr: { createMixrLoading,group }
    }
  } = useSelector((state) => state)
  useEffect(() => {
    if (!createMixrLoading && createUpdateErrors) {
      setErrorPublish(createUpdateErrors)
    } else {
      setErrorPublish('')
    }
  }, [createUpdateErrors, createMixrLoading])

  useEffect(() => {
    if (!saveDraft.loading && saveDraft.success) {
      isDraftSaved.current = true
      localStorage.removeItem('mixr_preview')
      setErrorDraft('')
      // dispatch(mixrActions.resetSaveDraftData())
      if (isSaveDraftModalOpen) {
        leavePage()
      } else {
        redirectToPage(`/0/${appConstantSettings.DEFAULT_HOMEPAGE}`)
      }
    }
  }, [saveDraft.loading])
  useEffect(() => {
    if (!saveDraft.loading && saveDraft.error) {
      setErrorDraft(saveDraft.error)
    } else {
      setErrorDraft('')
    }
  }, [saveDraft.loading, saveDraft.error])

  ///this hook will be used when there is redirection is not by react-routing. e.g clicking on anchor tag
  //not able to show custom modal here.
  useBeforeunload((event) => {
    if (!isNative && !isDraftSaved.current) {
      event.stopPropagation()
      event.preventDefault()
    }
  })

  useEffect(() => {
    if (props && props.history) {
      //unblock react routing if target redirection page is not create-mixr/edit-preview and home/event
      unblockRef.current = props.history.block((prompt) => {
        if (
          isDraftSaved.current ||
          prompt.pathname.includes('edit-preview') ||
          prompt.pathname.includes('home/event')
        ) {
          setErrorDraft('')
          return true
        } else {
          setCurrentPath(prompt.pathname)
          setIsSaveDraftModalOpen(true)
          return false
        }
      })
    }
    return () => {
      unblockRef.current && unblockRef.current()
      dispatch(mixrActions.resetSaveDraftError())
    }
  }, [])

  const closeModal = () => {
    setIsSaveDraftModalOpen(false)
  }

  const handleLeave = () => {
    leavePage()
  }

  const leavePage = () => {
    localStorage.removeItem('mixr_preview')
    props.history.block(() => {})
    dispatch(mixrActions.resetSaveDraftData())
    if (currentPath) {
      // window.location = `${config.webUrl}${currentPath}`
      props.history.push(currentPath)
    }
  }

  const handleSaveDraft = () => {
    const mixrInfomation = getCreateMixrParams(mixr)
    dispatch(mixrActions.saveDraft(mixrInfomation))
  }

  const handleCreateMixr = () => {
    const mixrInfomation = getCreateMixrParams(mixr)
    dispatch(mixrActions.createMixr(mixrInfomation.group_id, mixrInfomation))
  }

  return (
    <React.Fragment>
      <div className={styles.previewHeaderContainer}>
        <div className={styles.previewHeader}>
          <h1 className={styles.title}>{t('mixrPreview.title')}</h1>
          {isDraftSaved.current ? (
            <div className={styles.buttons}>
              <LinkButton
                size='large'
                style='secondary'
                text={t('global.createAnotherMixr')}
                href='/0/create-mixr'
                reactLink={!isNative}
              />
              {!isMobile && !isNative && (
                <LinkButton size='large' text={t('global.gotoHome')} href='/0/myhome' reactLink={!isNative} />
              )}
            </div>
          ) : (
            <div className={styles.buttons}>
              {(errorDraft || errorPublish) && !isMobile && !isNative ? (
                <ErrorMessage className={styles.error} text={errorDraft || errorPublish} />
              ) : null}
              <Button
                customStyle={styles.button}
                style='secondary'
                size='large'
                text={t('mixrPreview.saveDraft.btn')}
                handleClick={handleSaveDraft}
              />
              <Button
                customStyle={styles.button}
                style='secondary'
                size='large'
                text={isMobile || isNative ? t('global.edit') : t('mixrPreview.continueEditing')}
                handleClick={() => {
                  redirectToPage(`/0/create-mixr/edit-preview`)
                }}
              />
              <Button
                customStyle={styles.button}
                handleClick={handleCreateMixr}
                size='large'
                text={isMobile || isNative ? group?.can_suggest_mixr===1?t('event.create.btnSuggestMixR'):  t('global.publish') : group?.can_suggest_mixr===1?t('event.create.btnSuggestMixR'): t('mixrPreview.publish')}
              />
            </div>
          )}
        </div>
        {(errorDraft || errorPublish) && (isMobile || isNative) ? (
          <ErrorMessage className={styles.error} text={errorDraft || errorPublish} />
        ) : null}
        <div className={styles.previewWarning}>{t('mixrPreview.warning')}</div>
      </div>

      {isSaveDraftModalOpen && (
        <SaveDraftModal
          isOpen={isSaveDraftModalOpen}
          closeModal={closeModal}
          handleLeave={handleLeave}
          handleSaveDraft={handleSaveDraft}
          error={errorDraft}
        />
      )}
    </React.Fragment>
  )
}

export default Preview
